__turbopack_context__.v({
  "arrow": "styles-module-scss-module__400saa__arrow",
  "caption": "styles-module-scss-module__400saa__caption",
  "dropdownTrigger": "styles-module-scss-module__400saa__dropdownTrigger",
  "enter": "styles-module-scss-module__400saa__enter",
  "exit": "styles-module-scss-module__400saa__exit",
  "fade-in": "styles-module-scss-module__400saa__fade-in",
  "fade-out": "styles-module-scss-module__400saa__fade-out",
  "fade-out-80": "styles-module-scss-module__400saa__fade-out-80",
  "label": "styles-module-scss-module__400saa__label",
  "slide-in-from-bottom": "styles-module-scss-module__400saa__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__400saa__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__400saa__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__400saa__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__400saa__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__400saa__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__400saa__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__400saa__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__400saa__zoom-in",
  "zoom-out": "styles-module-scss-module__400saa__zoom-out",
});
